
import client from './client';

export interface Tag {
    id: string;
    name: string;
}

export const getTags = async (params?: { storeId?: string; sellerId?: string }): Promise<Tag[]> => {
    const response = await client.get('tags', { params });
    return response.data;
};

export const getAdminTags = async (): Promise<Tag[]> => {
    const response = await client.get('tags/admin');
    return response.data;
};

export const createTag = async (name: string): Promise<Tag> => {
    const response = await client.post('tags', { name });
    return response.data;
};

export const updateTag = async (id: string, name: string): Promise<Tag> => {
    const response = await client.patch(`tags/${id}`, { name });
    return response.data;
};

export const deleteTag = async (id: string): Promise<void> => {
    await client.delete(`tags/${id}`);
};
